<template>
  <div>
    <h2 class="text-h3 mb-3">Source Articles</h2>
    <NewsTab :market="slug" :categories-articles="categoriesArticles" />

    <h2 class="text-h3 mb-3 mt-6">Price Analysis</h2>
    <PriceAnalysisTab
      :name="NATURAL_GRAPHITE.name"
      :slug="NATURAL_GRAPHITE.slug"
      :service-base-path="NATURAL_GRAPHITE.serviceBasePath"
      :icon="NATURAL_GRAPHITE.icon"
    />
  </div>
</template>

<script lang="ts" setup>
import { NATURAL_GRAPHITE } from '~/constants/services/constants'
import PriceAnalysisTab from '~/components/market-insights/PriceAnalysisTab.vue'
import NewsTab from '~/components/market-insights/NewsTab.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  slug: string
  categoriesArticles?: string[]
}>()
</script>
